<!-- 置顶 -->
<template>
    <div
        class="topping"
        @click="topClick()"
        v-show="topShow"
    >
        <el-icon>
            <Top />
        </el-icon>
    </div>
</template>

<script setup>
import { Top } from '@element-plus/icons-vue'
import { ref } from 'vue';


let topClick = () => {
    window.scrollTo(0, 0); // 滚动到页面的左上角
}

let topShow = ref(true)

if (window.pageYOffset == 0) {
    topShow.value = false;
}

window.addEventListener('scroll', (event) => {
    // console.log("event", window.pageYOffset)

    if (window.pageYOffset == 0) {
        topShow.value = false;
    } else {
        topShow.value = true;
    }

})
</script>

<style lang="scss" scoped>
.topping {
    width: 3rem;
    height: 3rem;
    position: fixed;
    bottom: 5rem;
    right: 2rem;
    border: 1px solid rgba(173, 170, 170, 0.349);
    color: rgba(173, 170, 170, 0.349);
    border-radius: 50%;
    font-size: 2rem;
    line-height: 3.5rem;
    text-align: center;
    cursor: pointer;

    &:hover {
        border: 1px solid rgba(173, 170, 170, 0.616);
        color: rgba(173, 170, 170, 0.616);
    }
}
</style>